module.exports = __webpack_public_path__ + "img/c5201704.3f463523.jpg";